import React from 'react';
import Header from './Header';

const CustomerLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="pt-20 pb-8">
        {children}
      </main>
    </div>
  );
};

export default CustomerLayout;